import { render, staticRenderFns } from "./share_detail.vue?vue&type=template&id=2b7c9806&scoped=true"
import script from "./share_detail.vue?vue&type=script&lang=js"
export * from "./share_detail.vue?vue&type=script&lang=js"
import style0 from "./share_detail.vue?vue&type=style&index=0&id=2b7c9806&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7c9806",
  null
  
)

export default component.exports